<div class="container mt-5">
	<!-- Admin org select -->
	@if (api.user?.role === 'admin' || api.user?.role === 'master') {
		<div class="panel">
			<div class="heading">Global admin only - select organization</div>
			<div class="content">
				<div class="row">
					<div class="col-sm-6">
						<div class="mb-3">
							<select [ngModel]="organization" (ngModelChange)="SelectOrganization($event)" class="form-control">
								@for (org of organizations; track org) {
									<option [ngValue]="org">{{org.name}}</option>
								}
							</select>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
	<!-- User select / add -->
	<div class="panel expander">
		<div class="heading" (click)="$event.target.parentElement.classList.toggle('collapsed')">Users for {{organization?.name}}</div>
		<div class="content nopad">
			<div class="row mb-3">
				<div class="col-sm-6">
					<div class="list-group mb-3">
						@for (user of users; track user) {
							<a (click)="SelectUser(user)" [class.active]="selecteduser === user" href="javascript:void(0)"
								class="list-group-item list-group-item-action d-flex align-items-center justify-content-between">
								<div>{{user.email}}</div>
								<div class="text-end">
									@if (user.mfa_enabled) {
										<span class="badge text-bg-success mx-1">MFA Enabled</span>
									}
									@if (user.support) {
										<span class="badge text-bg-light mx-1">Support</span>
									}
									@if (user.role === 'readonly') {
										<span class="badge text-bg-secondary mx-1">Read Only</span>
									}
									@if (user.role === 'orgadmin') {
										<span class="badge text-bg-warning mx-1">Org Admin</span>
									}
									@if (user.role === 'admin') {
										<span class="badge text-bg-danger mx-1">Global Admin</span>
									}
									@if (user.role === 'master') {
										<span class="badge text-bg-master mx-1">Master Admin</span>
									}
								</div>
							</a>
						}
					</div>
					@if (!showadduser) {
						<div>
							<button (click)="showadduser = true" class="button">
								<i class="icon-plus-circled"></i>Add a new user</button>
						</div>
					}
					@if (showadduser) {
						<div>
							<hr>
							<div class="section-title mb-4">Add a new user</div>
							<div class="mb-3 row">
								<label class="col-md-4">Email address</label>
								<div class="col-md-8">
									<input [(ngModel)]="adduser.email" type="email" class="form-control">
								</div>
							</div>
							<div class="mb-3 row">
								<label class="col-md-4">Password</label>
								<div class="col-md-8">
									<input [(ngModel)]="adduser.password" type="password" class="form-control" autocomplete="new-password">
								</div>
							</div>
							<div class="mb-3 row">
								<label class="col-md-4">Role:</label>
								<div class="col-md-8">
									<div class="form-check">
										<label>
											<input [(ngModel)]="adduser.role" type="radio" value="orgadmin">
											Organization Administrator
										</label>
									</div>
									<div class="form-check">
										<label>
											<input [(ngModel)]="adduser.role" type="radio" value="user"> User
										</label>
									</div>
									<div class="form-check">
										<label>
											<input [(ngModel)]="adduser.role" type="radio" value="readonly"> Read
											Only
										</label>
									</div>
								</div>
							</div>
							@if (addusererrormessage) {
								<div class="mb-3 row">
									<div class="col-md-8 offset-md-4">
										<div class="message-bad">{{addusererrormessage}}</div>
									</div>
								</div>
							}
							<div class="col-md-8 offset-md-4">
								<button (click)="AddUser()" class="button green">Add User</button>
								<button (click)="showadduser = false" class="button ms-3">Cancel</button>
							</div>
						</div>
					}
				</div>
				@if (!selecteduser) {
					<div #userPanel class="col-sm-6 p-3">
						No user selected
					</div>
				}
				@if (selecteduser) {
					<div #userPanel class="col-sm-6 p-3 pe-5">
						<h4 class="mb-3">{{selecteduser.email}}</h4>
						@if ((selecteduser.role !== 'admin' && selecteduser.role !== 'master') && selecteduser.user_id !== api.user.user_id) {
							<div class="mb-3">
								<hr>
								<div class="mb-3 row">
									<label class="col-md-4">Role:</label>
									<div class="col-md-8">
										<div class="form-check">
											<label>
												<input [ngModel]="selecteduser.role" (ngModelChange)="newrole=$event" type="radio" value="orgadmin"> Organization Administrator
											</label>
										</div>
										<div class="form-check">
											<label>
												<input [ngModel]="selecteduser.role" (ngModelChange)="newrole=$event" type="radio" value="user"> User
											</label>
										</div>
										<div class="form-check">
											<label>
												<input [ngModel]="selecteduser.role" (ngModelChange)="newrole=$event" type="radio" value="readonly"> Read Only
											</label>
										</div>
									</div>
								</div>
								<div class="mb-3 row">
									<label class="col-md-4">Hide views:</label>
									<div class="col-md-8">
										<div class="form-check">
											<label>
												<input [(ngModel)]="selecteduser.hide_rtb" type="checkbox"> RTB
											</label>
										</div>
										<div class="form-check">
											<label>
												<input [(ngModel)]="selecteduser.hide_fdm" type="checkbox"> FDM
											</label>
										</div>
										<div class="form-check">
											<label>
												<input [(ngModel)]="selecteduser.hide_mech" type="checkbox"> Mechanical
											</label>
										</div>
									</div>
								</div>
								<div class="mb-3 row">
									<div class="col-md-8 offset-md-4">
										<app-action-button [action]="UpdateUser" [context]="this" processing="Updating..." complete="User updated">Update
											User</app-action-button>
									</div>
								</div>
							</div>
						}
						@if (((selecteduser.role !== 'admin' && selecteduser.role !== 'master') || api.user.role === 'admin' || api.user.role === 'master') && (selecteduser.user_id !==
					api.user.user_id)) {
							<div class="mb-3">
								<hr>
								<div class="mb-3 row">
									<div class="col-lg-7">
										<input type="password" [(ngModel)]="newpassword" class="form-control" placeholder="New password">
									</div>
									<div class="col-lg-5 mt-md">
										<app-action-button [action]="SetPassword" [context]="this" processing="Updating..." complete="Password reset" btnClass="block">Reset
											Password</app-action-button>
									</div>
								</div>
							</div>
						}
						@if (((selecteduser.role !== 'admin' && selecteduser.role !== 'master') || api.user.role === 'admin' || api.user.role === 'master') && (selecteduser.user_id !==
					api.user.user_id)) {
							<div class="mb-3">
								<hr>
								<div class="mb-3 row">
									<div class="col-lg-7">
										<input type="email" [(ngModel)]="newemail" class="form-control" placeholder="New email">
									</div>
									<div class="col-lg-5 mt-md">
										<app-action-button [action]="RenameUser" [context]="this" processing="Updating..." complete="Email changed, please refresh" btnClass="block">Change
											Email</app-action-button>
									</div>
								</div>
							</div>
						}
						<div>
							<hr>
							<div class="mb-3 row">
								<div class="col-lg-7">
									<label>Send a test email</label>
								</div>
								<div class="col-lg-5">
									<app-action-button [action]="SendEmail" [context]="this" processing="Sending..." complete="Email sent" btnClass="block">Send
										Email</app-action-button>
								</div>
							</div>
						</div>
						@if ((selecteduser.role !== 'admin' && selecteduser.role !== 'master') && selecteduser.user_id !== api.user.user_id && selecteduser.mfa_enabled) {
							<div class="mb-3">
								<hr>
								<div class="mb-3 row">
									<div class="col-lg-7">
										<label>Disable MFA (admin only)</label>
									</div>
									<div class="col-lg-5">
										<app-action-button [action]="DisableMFA" [context]="this" processing="Disabling..." complete="MFA disabled" btnClass="red block"
											confirm="Disable MFA for this user?">Disable MFA</app-action-button>
									</div>
								</div>
							</div>
						}
						@if ((selecteduser.role !== 'admin' && selecteduser.role !== 'master') && selecteduser.user_id !== api.user.user_id) {
							<div class="mb-3">
								<hr>
								<div class="mb-3 row">
									<div class="col-lg-7">
										<label>Permanently delete this user (admin only)</label>
									</div>
									<div class="col-lg-5">
										<app-action-button [action]="DeleteUser" [context]="this" processing="Deleting..." complete="User deleted" btnClass="red block"
											confirm="Permanently delete this user?">Delete User</app-action-button>
									</div>
								</div>
							</div>
						}
					</div>
				}
			</div>
		</div>
	</div>
	<!-- Asset select / add -->
	<div class="panel expander">
		<div class="heading" (click)="$event.target.parentElement.classList.toggle('collapsed')">Assets for {{organization?.name}}</div>
		<div class="content nopad">
			<div class="row mb-3">
				<div class="col-sm-6">
					<div class="list-group mb-3">
						@for (asset of assets; track asset) {
							<a (click)="SelectAsset(asset)" [class.active]="selectedasset === asset" href="javascript:void(0)"
								class="list-group-item list-group-item-action d-flex align-items-center justify-content-between">
								<span>{{asset.asset_name}} ({{asset.obcu_serial_number}})</span>
								@if (asset.fleet_id) {
									<span class="badge text-bg-success">{{asset.fleet_name}}</span>
								}
								@if (!asset.fleet_id) {
									<span class="badge text-bg-danger">Not assigned</span>
								}
							</a>
						}
					</div>
				</div>
				@if (!selectedasset) {
					<div #assetPanel class="col-sm-6 p-3">
						No asset selected
					</div>
				}
				@if (selectedasset) {
					<div #assetPanel class="col-sm-6 p-3 pe-5">
						<h4 class="mb-3">OBCU: {{selectedasset.obcu_serial_number}}</h4>
						<hr>
						<div class="mb-3 row">
							<label class="col-md-4">Configuration Type:</label>
							<div class="col-md-8">
								<select [(ngModel)]="updateasset.config" class="form-control">
									@for (config of configs; track config) {
										<option [ngValue]="config">{{config.asset_type_name}}</option>
									}
								</select>
							</div>
						</div>
						<div class="mb-3 row">
							<label class="col-md-4">Asset name:</label>
							<div class="col-md-8">
								<input [(ngModel)]="updateasset.asset_name" type="text" class="form-control">
							</div>
						</div>
						<div class="mb-3 row">
							<label class="col-md-4">{{brand.fleetSingular}}:</label>
							<div class="col-md-8">
								<select [(ngModel)]="updateasset.fleet" class="form-control">
									@for (fleet of fleets; track fleet) {
										<option [ngValue]="fleet">{{fleet.fleet_name}}</option>
									}
								</select>
							</div>
						</div>
						<div class="mb-3 row">
							<label class="col-md-4">Total flight time offset (hrs):</label>
							<div class="col-md-8">
								<input type="number" [(ngModel)]="updateasset.flight_time_offset" class="form-control">
							</div>
						</div>
						<div class="mb-3 row">
							<label class="col-md-4">Ignore Caution / Advisories:</label>
							<div class="col-md-8">
								<input type="checkbox" [(ngModel)]="updateasset.severe_exceedances_only">
							</div>
						</div>
						<div class="mb-3 row">
							<div class="col-md-8 offset-md-4">
								<app-action-button [action]="UpdateAsset" [context]="this" processing="Updating..." complete="Asset updated">Update
									Asset</app-action-button>
							</div>
						</div>
						<p>Note that changing these parameters requires that the OBCU configuration be updated to match exactly.
							Any incoming
							data with different values will be discarded.</p>
						@if (assetPartners && assetPartners.length > 0) {
							<div>
								<hr>
								<h5>Partner sharing</h5>
								<div>Note: this asset is being shared with:</div>
								<ul class="partner-list">
									@for (partner of assetPartners; track partner) {
										<li>
											{{ partner }}
										</li>
									}
								</ul>
							</div>
						}
					</div>
				}
			</div>
		</div>
	</div>
	<!-- Fleet select / add -->
	<div class="panel expander">
		<div class="heading" (click)="$event.target.parentElement.classList.toggle('collapsed')">{{brand.fleetPlural}} for {{organization?.name}}</div>
		<div class="content nopad">
			<div class="row mb-3">
				<div class="col-sm-6">
					<div class="list-group mb-3">
						@for (fleet of fleets; track fleet) {
							<a (click)="SelectFleet(fleet)" [class.active]="selectedfleet === fleet" href="javascript:void(0)" class="list-group-item list-group-item-action">
								<span>{{fleet.fleet_name}}</span>
							</a>
						}
					</div>
					@if (!showaddfleet) {
						<div>
							<button (click)="showaddfleet = true" class="button">
								<i class="icon-plus-circled"></i>Add a new {{brand.fleetSingular}}</button>
						</div>
					}
					@if (showaddfleet) {
						<div>
							<hr>
							<div class="section-title mb-4">Add a new {{brand.fleetSingular}}</div>
							<div class="mb-3 row">
								<label class="col-md-4">{{brand.fleetSingular}} name</label>
								<div class="col-md-8">
									<input [(ngModel)]="addfleetname" type="text" class="form-control">
								</div>
							</div>
							@if (addfleeterrormessage) {
								<div class="mb-3 row">
									<div class="col-md-8 offset-md-4">
										<div class="message-bad">{{addfleeterrormessage}}</div>
									</div>
								</div>
							}
							<div class="mb-3 row">
								<div class="col-md-8 offset-md-4">
									<button (click)="AddFleet()" class="button green">Add {{brand.fleetSingular}}</button>
									<button (click)="showaddfleet = false" class="button ms-3">Cancel</button>
								</div>
							</div>
						</div>
					}
				</div>
				@if (!selectedfleet) {
					<div #fleetPanel class="col-sm-6 p-3">
						No fleet selected
					</div>
				}
				@if (selectedfleet) {
					<div #fleetPanel class="col-sm-6 p-3 pe-5">
						<h4 class="mb-3">{{selectedfleet.fleet_name}}</h4>
						<hr>
						<div class="mb-3 row">
							<label class="col-md-4">Time display offset (hrs):</label>
							<div class="col-md-8">
								<input class="form-control" type="number" [(ngModel)]="selectedfleet.time_offset_hours">
							</div>
						</div>
						@if (updatefleeterrormessage) {
							<div class="mb-3 row">
								<div class="col-md-8 offset-md-4">
									<div class="message-bad">{{updatefleeterrormessage}}</div>
								</div>
							</div>
						}
						<div class="mb-3 row">
							<div class="col-md-8 offset-md-4">
								<app-action-button [action]="UpdateFleet" [context]="this" processing="Updating..." complete="{{brand.fleetSingular}} updated">Update
									{{brand.fleetSingular}}
								</app-action-button>
							</div>
						</div>
						<hr>
						<div class="mb-3 row">
							<div class="col-md-6">Permanently delete this {{brand.fleetSingular}}</div>
							<div class="col-md-6 mt-sm">
								<app-action-button [action]="DeleteFleet" [context]="this" processing="Deleting..." complete="{{brand.fleetSingular}} deleted" btnClass="red block"
									confirm="Are you sure? Any assets in this {{brand.fleetSingular}} will not be deleted but will need to be assigned to a different {{brand.fleetSingular}}.">
									Delete Fleet</app-action-button>
							</div>
						</div>
					</div>
				}
			</div>
		</div>
	</div>
</div>